import React from 'react';

class TabsContainer extends React.Component {
  static defaultProps = {
    activeTab: 0,
  };

  render() {
    return (
      this.props.children[this.props.activeTab] ? (
        <div className="tabs__body">
          <div className="tabs__content is-active">
            <section className="section section--pt-lg section--pb-lg">
              <div className="container">
                <div className="row">
                  <div className="section__content">
                    {this.props.children[this.props.activeTab]}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      ) : ''
    );
  }
}

export default TabsContainer;
